import MainHeader from './components/MainHeader';
import Underlines from './underlines';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resized);
		window.addEventListener('load', this.loaded);
	}

	init() {
		MainHeader.init();
		Underlines.init();
	}

	resized() {
		MainHeader.resized();
	}

	loaded() {
		MainHeader.loaded();
	}
}

// Run controller.
new Controller();
